<div class="node-page custom-page">
    <app-data-table addButtonText="{{ 'NodePage.AddButton' | translate }}" title="{{ 'NodePage.Title' | translate }}" filterPlaceholder="{{ 'NodePage.FilterPlaceholder' | translate }}"
        (openModal)="openNode($event)" (deleteRow)="deleteNodeComponent($event)" [displayedColumnsName]="displayedColumnsName"
        [displayedColumns]="displayedColumns" [data]="nodes"  >
        <!-- [buttonActive]="true" secondButtonText="{{ 'NodePage.Arch' | translate }}" (secondButtonFunc)="gotoArchPage()" -->
       
    </app-data-table>
</div>